<template>
  <section class="user2-vip-page">
    <header class="vip2-page-header">
      <div>
        <span class="vip2-eyebrow">MEMBERSHIP</span>
        <h1>购买会员</h1>
        <p>选择适合你的会员方案，解锁更多创作权益</p>
      </div>
      <div class="vip2-header-icon">
        <app-icon  class="app-icon" name="workspace_premium"></app-icon>
      </div>
    </header>

    <LegacyVip />
  </section>
</template>

<script>
import LegacyVip from '../User/Vip.vue'

export default {
  name: 'User2Vip',
  components: { LegacyVip }
}
</script>

<style scoped>
.user2-vip-page { min-height: 100%; padding: 28px; box-sizing: border-box; background: #f8fafc; color: #0f172a; }
.vip2-page-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; max-width: 1100px; margin: 0 auto 24px; }
.vip2-eyebrow { display: block; margin-bottom: 8px; color: #2563eb; font-size: 10px; font-weight: 700; letter-spacing: .16em; }
.vip2-page-header h1 { margin: 0; font-size: 28px; line-height: 1.3; }
.vip2-page-header p { margin: 8px 0 0; color: #64748b; font-size: 14px; line-height: 1.6; }
.vip2-header-icon { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 52px; height: 52px; border-radius: 16px; background: #eaf2ff; color: #2563eb; font-size: 28px; }
.user2-vip-page /deep/ > div { max-width: 1100px; min-width: 0; margin: 0 auto; padding: 26px !important; border: 1px solid #e2e8f0; border-radius: 20px !important; background: #fff !important; box-shadow: 0 8px 30px rgba(15, 23, 42, .03); }
.user2-vip-page /deep/ .capsule-selector { margin: 0 0 26px; padding: 0; }
.user2-vip-page /deep/ .capsule-container { min-width: 0; max-width: 640px; padding: 5px; background: #f1f5f9; border: 0; border-radius: 14px; box-shadow: none; }
.user2-vip-page /deep/ .capsule-item { padding: 13px 14px; margin: 0; border-radius: 10px; color: #64748b; }
.user2-vip-page /deep/ .capsule-item.active { background: #fff; color: #2563eb; text-shadow: none; box-shadow: 0 2px 6px rgba(15, 23, 42, .08); }
.user2-vip-page /deep/ .capsule-desc { margin-top: 5px; color: inherit; }
.user2-vip-page /deep/ .vip-cards-container { margin: 0 0 26px; min-width: 0; }
.user2-vip-page /deep/ .vip-cards-grid { max-width: none; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; padding: 0; }
/* 会员权益区：卡片下方一份，跟随当前选中套餐（数据见 User/Vip.vue 的 benefits-panel） */
.user2-vip-page /deep/ .benefits-panel { margin: 18px 0 22px; padding: 18px 20px; border: 1px solid #e2e8f0; border-radius: 14px; background: #f8fafc; }
.user2-vip-page /deep/ .benefits-header { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 12px; }
.user2-vip-page /deep/ .benefits-title { color: #0f172a; font-size: 14px; font-weight: 600; }
.user2-vip-page /deep/ .benefits-plan { color: #2563eb; font-size: 12px; font-weight: 600; }
.user2-vip-page /deep/ .benefits-panel .features-list { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 0 16px; margin: 0; }
.user2-vip-page /deep/ .vip-card { min-width: 0; padding: 24px 20px 18px; background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; box-shadow: none; }
.user2-vip-page /deep/ .vip-card:hover { transform: translateY(-2px); border-color: #93c5fd; box-shadow: 0 8px 20px rgba(37, 99, 235, .06); }
.user2-vip-page /deep/ .vip-card.selected { transform: none; background: #eff6ff; border-color: #2563eb; color: #334155; box-shadow: inset 0 0 0 1px #2563eb; }
/* ⚠️ 1.0 的选中态是「深蓝渐变底 + 白字」，它那套 .vip-card.selected X 与上面的
   .user2-vip-page[data-v] X 优先级相同(0,3,0)，谁在后面谁赢——实测 1.0 赢，于是
   选中卡片成了「浅蓝底 + 白字」糊成一片，且选中后对勾还会突然变成实心绿圆
   （1.0 那条是 (0,4,0)）。所以选中态的子元素必须写全，把优先级抬到 (0,4,0) 以上，
   跟加载顺序彻底解耦。改选中态配色时，务必连着这一块一起改。 */
.user2-vip-page /deep/ .vip-card.popular.selected { background: #eff6ff; border-color: #2563eb; }
.user2-vip-page /deep/ .vip-card.selected .plan-icon { background: #eaf2ff; backdrop-filter: none; }
.user2-vip-page /deep/ .vip-card.selected .plan-name { color: #0f172a; }
.user2-vip-page /deep/ .vip-card.selected .plan-features { color: #64748b; }
.user2-vip-page /deep/ .vip-card.selected .currency,
.user2-vip-page /deep/ .vip-card.selected .amount { color: #2563eb; }
.user2-vip-page /deep/ .vip-card.selected .period,
.user2-vip-page /deep/ .vip-card.selected .price-daily { color: #64748b; }
.user2-vip-page /deep/ .plan-icon { width: 38px; height: 38px; border-radius: 11px; background: #eaf2ff; }
.user2-vip-page /deep/ .plan-icon i { color: #2563eb; }
.user2-vip-page /deep/ .plan-name { color: #0f172a; font-size: 17px; }
.user2-vip-page /deep/ .plan-features { color: #64748b; font-size: 12px; line-height: 1.6; }
.user2-vip-page /deep/ .price-section { background: #f8fafc; padding: 18px 8px; }
.user2-vip-page /deep/ .vip-card.selected .price-section { background: #dbeafe; }
.user2-vip-page /deep/ .currency, .user2-vip-page /deep/ .amount { color: #2563eb; }
.user2-vip-page /deep/ .amount { font-size: 34px; }
.user2-vip-page /deep/ .period, .user2-vip-page /deep/ .price-daily { color: #64748b; }
.user2-vip-page /deep/ .feature-item span { color: #475569; }
.user2-vip-page /deep/ .feature-icon.supported { color: #16a34a; background: transparent; }
.user2-vip-page /deep/ .feature-icon.unsupported { color: #94a3b8; background: transparent; }
.user2-vip-page /deep/ .popular-badge { right: 16px; padding: 4px 12px; background: #2563eb; font-size: 11px; box-shadow: none; }
.user2-vip-page /deep/ .selection-indicator { background: #2563eb; }
.user2-vip-page /deep/ .balance-payment { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; margin: 0 0 22px; padding: 20px; border-radius: 14px; background: #f8fafc; }
.user2-vip-page /deep/ .balance-payment .el-radio { display: flex; align-items: center; justify-content: center; min-width: 172px; margin: 0; padding: 13px 16px; border: 1px solid #e2e8f0; border-radius: 10px; background: #fff; white-space: normal; }
.user2-vip-page /deep/ .balance-payment .el-radio.is-checked { border-color: #2563eb; background: #eff6ff; }
/* 去掉单选圆点，选中只靠卡片边框 + 底色（框选）。注意 Element 的 label 是 input 的
   兄弟节点，所以下面 .is-checked + .el-radio__label 那两条依然生效 */
.user2-vip-page /deep/ .balance-payment .el-radio__input { display: none; }
.user2-vip-page /deep/ .balance-payment .el-radio__label { padding-left: 0; line-height: 1.5; }
.user2-vip-page /deep/ .balance-payment .pay-opt { gap: 8px; }
.user2-vip-page /deep/ .balance-payment .pay-opt-icon { width: 22px; height: 22px; border-radius: 6px; }
.user2-vip-page /deep/ .balance-payment .pay-opt-icon--balance { font-size: 21px; color: #2563eb; }
/* Element 选中态默认走 #409EFF，和本页主色 #2563eb 不一致，一并压过来 */
.user2-vip-page /deep/ .balance-payment .el-radio__input.is-checked .el-radio__inner { background: #2563eb; border-color: #2563eb; }
.user2-vip-page /deep/ .balance-payment .el-radio__input.is-checked + .el-radio__label { color: #2563eb; font-weight: 600; }
/* 禁用的选项（余额不足）Element 只置灰文字，图标也跟着淡下去才一致 */
.user2-vip-page /deep/ .balance-payment .el-radio.is-disabled .pay-opt-icon { opacity: .45; }
.user2-vip-page /deep/ .purchase-section { margin: 0 0 24px; }
.user2-vip-page /deep/ .purchase-button { width: 320px; max-width: 100%; height: 54px; border-radius: 12px; background: #2563eb; box-shadow: 0 4px 12px rgba(37, 99, 235, .16); }
.user2-vip-page /deep/ .button-background, .user2-vip-page /deep/ .button-shine { display: none; }
.user2-vip-page /deep/ .payment-tooltip { position: static; justify-content: center; margin-top: 12px; padding: 0; background: transparent; border: 0; box-shadow: none; color: #64748b; }
.user2-vip-page /deep/ .payment-tooltip i { color: #64748b; }
.user2-vip-page /deep/ .terms-container { border: 1px solid #e2e8f0; background: #fff; border-radius: 14px; box-shadow: none; padding: 20px; }
.user2-vip-page /deep/ .loading-overlay { background: transparent; backdrop-filter: none; }
.user2-vip-page /deep/ .loading-content { flex-direction: row; gap: 10px; padding: 0; background: transparent; border: 0; box-shadow: none; min-width: 0; min-height: 0; }
.user2-vip-page /deep/ .loading-icon { font-size: 24px; color: #2563eb; filter: none; }
.user2-vip-page /deep/ .loading-text { font-size: 14px; color: #64748b; font-weight: 400; text-shadow: none; }
/* 弹窗按可用视口布局，内容滚动，头部关闭按钮始终可见。 */
.user2-vip-page /deep/ .payment-modal-overlay { padding: 16px; box-sizing: border-box; background: rgba(15, 23, 42, .55); backdrop-filter: blur(4px); }
.user2-vip-page /deep/ .payment-modal { display: flex; flex-direction: column; width: 420px; max-width: 100%; margin: 0; max-height: calc(100vh - 32px); max-height: calc(100dvh - 32px); background: #fff; border: 0; border-radius: 20px; box-shadow: 0 24px 70px rgba(15, 23, 42, .22); }
.user2-vip-page /deep/ .payment-header { flex-shrink: 0; padding: 16px 20px; background: #fff; color: #0f172a; border-bottom: 1px solid #e2e8f0; }
.user2-vip-page /deep/ .close-button { width: 40px; height: 40px; color: #64748b; background: #f1f5f9; }
.user2-vip-page /deep/ .payment-content { min-height: 0; padding: 20px; overflow-y: auto; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; }
.user2-vip-page /deep/ .product-name { font-size: 16px; overflow-wrap: anywhere; }
.user2-vip-page /deep/ .product-price { color: #2563eb; font-size: 32px; text-shadow: none; }
.user2-vip-page /deep/ .payment-divider { margin: 16px 0; background: #e2e8f0; }
.user2-vip-page /deep/ .qr-container { padding: 16px; background: #fff; border-radius: 14px; border: 1px solid #e2e8f0; box-shadow: none; }
.user2-vip-page /deep/ .qr-code { min-width: 0; min-height: 0; width: 180px; height: 180px; }
.user2-vip-page /deep/ .qr-code img, .user2-vip-page /deep/ .qr-code canvas { max-width: 100%; height: auto; object-fit: contain; }
.user2-vip-page /deep/ .qr-tappable { border-color: #86efac; }
.user2-vip-page /deep/ .payment-actions { flex-direction: row; gap: 10px; }
.user2-vip-page /deep/ .action-button { min-width: 0; min-height: 46px; height: 46px; border-radius: 10px; font-size: 14px; }
.user2-vip-page /deep/ .cancel-button { background: #f1f5f9; border: 1px solid #e2e8f0; color: #64748b; }
.user2-vip-page /deep/ .confirm-button { background: #2563eb; box-shadow: none; }
.user2-vip-page /deep/ .payment-tips { margin-top: 14px; padding: 12px; background: #f8fafc; }
.user2-vip-page /deep/ .tip-item { align-items: flex-start; line-height: 1.7; overflow-wrap: anywhere; }
@media (max-width: 768px) {
  .user2-vip-page { padding: 18px 14px 24px; }
  .vip2-page-header { margin-bottom: 18px; gap: 12px; }
  .vip2-page-header h1 { font-size: 24px; }
  .vip2-page-header p { font-size: 12px; }
  .vip2-header-icon { width: 44px; height: 44px; }
  .user2-vip-page /deep/ > div { padding: 16px !important; border-radius: 16px !important; }
  .user2-vip-page /deep/ .capsule-selector { margin-bottom: 18px; }
  .user2-vip-page /deep/ .capsule-item { padding: 12px 4px; }
  .user2-vip-page /deep/ .capsule-name { font-size: 13px; }
  .user2-vip-page /deep/ .capsule-desc { font-size: 10px; }
  /* 手机端一行两个：卡片只有一列时的一半宽，字号/间距必须整体跟着收，
     否则文字会挤成两三行甚至溢出 */
  .user2-vip-page /deep/ .vip-cards-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
  .user2-vip-page /deep/ .vip-card { padding: 14px 12px 12px; width: 100%; box-sizing: border-box; }
  .user2-vip-page /deep/ .card-header { margin-bottom: 10px; }
  .user2-vip-page /deep/ .plan-icon { width: 30px; height: 30px; border-radius: 9px; margin-right: 8px; }
  .user2-vip-page /deep/ .plan-icon i { font-size: 16px; }
  .user2-vip-page /deep/ .plan-info { min-width: 0; }
  .user2-vip-page /deep/ .plan-name { font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .user2-vip-page /deep/ .plan-features { font-size: 10px; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .user2-vip-page /deep/ .price-section { margin: 10px 0; padding: 10px 6px; }
  .user2-vip-page /deep/ .currency { font-size: 12px; }
  .user2-vip-page /deep/ .amount { font-size: 22px; }
  .user2-vip-page /deep/ .period { font-size: 10px; }
  .user2-vip-page /deep/ .price-daily { font-size: 10px; }
  /* 权益区现在是整宽面板（卡片里已无列表），字号比原来卡内小字略大一档 */
  .user2-vip-page /deep/ .benefits-panel { margin-bottom: 18px; padding: 14px; }
  .user2-vip-page /deep/ .benefits-panel .features-list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 10px; }
  .user2-vip-page /deep/ .feature-item { margin-bottom: 0; padding: 4px 0; }
  .user2-vip-page /deep/ .feature-icon { width: 14px; height: 14px; margin-right: 7px; font-size: 9px; }
  .user2-vip-page /deep/ .feature-item span { font-size: 12px; }
  .user2-vip-page /deep/ .popular-badge { right: 8px; padding: 3px 8px; font-size: 10px; border-radius: 0 0 8px 8px; }
  .user2-vip-page /deep/ .selection-indicator { top: 8px; right: 8px; width: 20px; height: 20px; font-size: 12px; }
  .user2-vip-page /deep/ .balance-payment { display: grid; grid-template-columns: minmax(0, 1fr); padding: 12px; text-align: left; }
  .user2-vip-page /deep/ .balance-payment .el-radio { justify-content: flex-start; min-width: 0; }
  .user2-vip-page /deep/ .purchase-button-wrapper, .user2-vip-page /deep/ .purchase-button-container { width: 100%; }
  .user2-vip-page /deep/ .purchase-button { width: 100%; }
  .user2-vip-page /deep/ .terms-container { padding: 14px; }
  .user2-vip-page /deep/ .agreement-text { line-height: 1.8; }
  .user2-vip-page /deep/ .payment-modal-overlay { padding: 12px; padding-bottom: max(12px, env(safe-area-inset-bottom)); }
  .user2-vip-page /deep/ .payment-modal { max-height: calc(100vh - 40px); max-height: calc(100dvh - 40px); border-radius: 16px; }
  .user2-vip-page /deep/ .payment-header { padding: 12px 16px; }
  .user2-vip-page /deep/ .payment-content { padding: 16px; }
  .user2-vip-page /deep/ .qr-section { gap: 12px; }
  .user2-vip-page /deep/ .payment-text { font-size: 13px; }
  /* 手机上二维码收到 148：180 在手机弹窗里几乎占满整行，太抢眼 */
  .user2-vip-page /deep/ .qr-code { width: 148px; height: 148px; }
  .user2-vip-page /deep/ .qr-container { padding: 12px; border-radius: 12px; }
}
@media (max-width: 360px) {
  .user2-vip-page { padding: 14px 10px; }
  .user2-vip-page /deep/ > div { padding: 12px !important; }
  .user2-vip-page /deep/ .vip-cards-grid { gap: 8px; }
  .user2-vip-page /deep/ .vip-card { padding: 12px 10px 10px; }
  .user2-vip-page /deep/ .amount { font-size: 20px; }
  .user2-vip-page /deep/ .feature-item span { font-size: 11px; }
  .user2-vip-page /deep/ .payment-content { padding: 12px; }
  .user2-vip-page /deep/ .qr-code { width: 132px; height: 132px; }
  .user2-vip-page /deep/ .qr-container { padding: 10px; border-radius: 12px; }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/Vip.vue